import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type RootState } from '../../../../app/store'

export interface EditPortfoliosState {
  settlementProjectId: number
  specificPortfolio: number
  transferButtonsEnabled: boolean
  refundButtonsEnabled: boolean
}

const initialState: EditPortfoliosState = {
  settlementProjectId: 0,
  specificPortfolio: 0,
  transferButtonsEnabled: false,
  refundButtonsEnabled: false
}

export const editPortfoliosSlice = createSlice({
  name: 'editPortfolios',
  initialState,
  reducers: {
    setSettlementProjectId: (state, action: PayloadAction<number>) => {
      state.settlementProjectId = action.payload
    },
    setSpecificPortfolio: (state, action: PayloadAction<number>) => {
      state.specificPortfolio = action.payload
    },
    setTransferButtonsEnabled: (state, action: PayloadAction<boolean>) => {
      state.transferButtonsEnabled = action.payload
    },
    setRefundButtonsEnabled: (state, action: PayloadAction<boolean>) => {
      state.transferButtonsEnabled = action.payload
    },
    resetPortfolios: (state) => {
      state.settlementProjectId = 0
      state.specificPortfolio = 0
      state.transferButtonsEnabled = false
      state.refundButtonsEnabled = false
    }
  }
})

export const {
  setSettlementProjectId,
  setSpecificPortfolio,
  setTransferButtonsEnabled,
  setRefundButtonsEnabled,
  resetPortfolios
} = editPortfoliosSlice.actions

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectSettlementProjectId = (state: RootState): number => state.portfoliosSlice.settlementProjectId
export const selectSpecificPortfolio = (state: RootState): number => state.portfoliosSlice.specificPortfolio

export const selectTransferButtonsEnabled = (state: RootState): boolean => state.portfoliosSlice.transferButtonsEnabled

export const selectRefundButtonsEnabled = (state: RootState): boolean => state.portfoliosSlice.refundButtonsEnabled

export default editPortfoliosSlice.reducer
